import { render, staticRenderFns } from "./LocationProfile.vue?vue&type=template&id=20a3ec40"
import script from "./LocationProfile.vue?vue&type=script&lang=js"
export * from "./LocationProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports